import * as types from "../types/userAccountInfo"

const initialSelectedCashierBranchState = {
  _id: "",
  name: "",
  address: "",
  city: "",
  state: "",
  contactNumber: "",
  location: { type: "Point", coordinates: [] },
  onlyThisDeliveries: [],
  snappboxFlag: false,
  customerAddressRules: {
    onlyFromBranchStateAndCity: false,
    recipientPhoneNumber: false,
    recipientName: false,
    zipCode: false
  },
  paymentOptions: {
    billplz: false,
    wallet: false,
    cash: false,
    cod: false,
    gkash: false,
    zarinpal: false,
    sadad: false,
    pna: false,
    bpMellat: false
  }
}

const initialState = {
  cashierBranches: [],
  branchId: "",
  branchName: "",
  selectedCashierBranch: initialSelectedCashierBranchState
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_USER_INFO: {
      const selectedCashierBranch =
        action.userAccountInfo.cashierBranches.find(cb =>
          cb._id === state.branchId
        ) ||
        initialSelectedCashierBranchState

      return {
        ...state,
        ...action.userAccountInfo,
        selectedCashierBranch
      }
    }
    case types.UPDATE_USER_INFO:
      return { ...state, ...action.userAccountInfo }
    case types.DELETE_USER_INFO:
      return {
        cashierBranches: [],
        branchId: "",
        selectedCashierBranch: { ...initialSelectedCashierBranchState }
      }
    default:
      return state
  }
}

export default userReducer